export type LanguagePreference = 'en' | 'fr';

const LANGUAGE_STORAGE_KEY = 'language';

export function readLanguagePreference(): LanguagePreference | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return savedLanguage === 'en' || savedLanguage === 'fr' ? savedLanguage : null;
  } catch {
    return null;
  }
}

export function saveLanguagePreference(language: LanguagePreference): void {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Ignore storage errors; the selected language still applies to the current page.
  }
}
